<template>
  <b-container fluid>
    <b-card border-variant="danger" :header="$t('EditItems.header')" header-bg-variant="danger" header-text-variant="white" align="left">
      <div>
        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab v-for="(lang, i) in langOptions" :key="i">
            <template v-slot:title>
              <country-flag :country="getLocale(lang)" size="normal" />
            </template>
          </b-tab>
        </b-tabs>
      </div>
      <b-form>
        <b-row class="my-1">
          <b-col>
            <b-form-select :options="dropDownList" required v-model="form.item"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-3" align-v="end">
          <b-col>
            <b-button :disabled="disabledBtn" variant="info" @click="editItem">{{ $t('EditItems.edit') }}</b-button>
            <b-button :disabled="disabledBtn" variant="danger" @click="showModal">{{ $t('EditItems.delete') }}</b-button>
          </b-col>
          <b-col>
            <b-button variant="info" class="float-right" @click="$router.push({ name: 'AddItem' })">{{ $t('EditItems.add') }}</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="error.received" variant="danger" class="text-center" dismissible>{{error.msg}}</b-alert>
          <b-alert :show="success.received" variant="success" class="text-center" dismissible>{{success.msg}}</b-alert>
        </b-row>
      </b-form>
    </b-card>
    <!-- DELETE MODAL -->
  <b-modal ref="deleteModalRef" hide-footer header-bg-variant="danger">
      <div class="d-block text-center">
        <h4>{{ $t('EditItems.modalConfirmation') }}</h4>
        <h3 v-if="selectedItem">{{filterLang(selectedItem)}}</h3>
      </div>
      <b-btn class="mt-3" cancel @click="hideModal">{{ $t('EditItems.modalConfirmationCancel') }}</b-btn>
      <b-btn class="mt-3" ok variant="danger" @click="deleteItem">{{ $t('EditItems.modalConfirmationDelete') }}</b-btn>
    </b-modal>
  </b-container>
</template>

<script>
/* CONTROLLER */
import ItemsService from '@/services/ItemsService'
import locales from '../i18n/locales'

export default {
  name: 'EditItems',
  data () {
    return {
      dropDownList: [{ value: null, text: this.$i18n.t('EditItems.dropDownList') }],
      error: {
        received: false,
        msg: ''
      },
      form: {
        item: null
      },
      items: [],
      langOptions: [],
      selectedItem: null,
      success: {
        received: false,
        msg: ''
      },
      tabIndex: 0,
      unfilteredItems: []
    }
  },
  mounted () {
    // redirect if user not logged in
    let smartdineLocalStorage = JSON.parse(window.localStorage.getItem('smartdine'))

    if (!smartdineLocalStorage.token) this.$router.push({ name: 'Login' })

    // else, get categories
    else {
      this.getItems()
      this.languageOptions()
    }
  },
  methods: {
    async getItems () {
      const response = await ItemsService.getItems()
      this.unfilteredItems = response.data.items

      this.filterItems()
    },
    getItem () {
      this.selectedItem = this.unfilteredItems.find(i => {
        return i._id === this.form.item
      })
    },
    filterItems () {
      // clear out items array if not empty
      if (this.items.length > 0) {
        this.items = []
      }

      // filter based on current language
      // and assign to items
      this.unfilteredItems.forEach(i => {
        this.items.push({ name: this.filterLang(i), _id: i._id })
      })

      // build drop-down list
      this.dropDownList = [{ value: null, text: this.$i18n.t('EditItems.dropDownList') }]
      this.items.forEach(i => this.dropDownList.push({ value: i._id, text: i.name }))
    },
    editItem () {
      this.getItem()

      // set currentItem state
      this.$store.dispatch('setCurrentItem', this.selectedItem)

      // navigate to edit item panel
      this.$router.push({ name: 'EditItem', params: { item: this.selectedItem._id } })
    },
    showModal () {
      this.getItem()
      this.$refs.deleteModalRef.show()
    },
    hideModal () {
      this.$refs.deleteModalRef.hide()
    },
    async deleteItem () {
      try {
        const response = await ItemsService.deleteItem({ _id: this.selectedItem._id })

        this.success.received = true
        this.success.msg = `${this.filterLang(response.data.item)} ${this.$i18n.t('EditItems.serverMessages.deleteSuccessMsg')}`
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }
      // take out category from drop-down list and reset form
      this.dropDownList = this.dropDownList.filter(i => { return i.value !== this.selectedItem._id })
      this.form.item = null

      this.hideModal()
    },
    languageOptions () {
      // get languages from i18n and assign value/text to langOptions
      this.langOptions = Object.keys(this.$i18n.messages).map(l => {
        return { value: l, text: l.toUpperCase() }
      })
    },
    filterLang (item) {
      // filter for selected language
      let locale = item.name.filter(n => { return n.lang === this.selectedLanguage })
      // if locale value undefined, filter for and assign a defined value
      return (locale.length > 0) ? locale[0].value : item.name.filter(n => { return n.value.length > 0 })[0].value
    },
    getLocale (lang) {
      return locales.filter(l => l.code === lang.value)[0].flag
    }
  },
  computed: {
    disabledBtn () {
      if (this.form.item === null) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    tabIndex () {
      if (this.tabIndex !== -1) {
        this.selectedLanguage = this.langOptions[this.tabIndex].value
        this.filterItems()
      }
    }
  }
}
</script>

<style scoped>
  .btn {
    margin: 0.1em 0.25em 0.1em 0.25em;
  }

  .modal-dialog h3 {
    color: #0d47a1;
  }
</style>



// WEBPACK FOOTER //
// src/components/EditItems.vue